import { useReactiveVar } from '@apollo/client';

import { currentAgencyVar } from '@/util/apollo/cache';

// GRAVY-10878: every ops rota call names the agency the tenant-admin
// shell is scoped to (`agencyByKey('gravy-dmv')`, kept in currentAgencyVar),
// so the Operations page, the admin's bar and the clients' bar all read the
// same rota. graphy ignores it for client admins (they read their own).

const toId = (id: string | number | null | undefined): number | null => {
  const n = Number(id);
  return id != null && Number.isInteger(n) && n > 0 ? n : null;
};

/** The shell's agency id now, or null before the shell has resolved it. */
export const currentOpsAgencyId = (): number | null =>
  toId(currentAgencyVar()?.id);

/** The same, as a hook: query keys carry it, so a late agency refetches. */
export const useOpsAgencyId = (): number | null =>
  toId(useReactiveVar(currentAgencyVar)?.id);
